import { Link as RouterLink } from 'react-router-dom';
import type { LinkProps as RouterLinkProps } from 'react-router-dom';
import { forwardRef } from 'react';

/**
 * FuseLink component
 * Wrapper for React Router Link
 */
const Link = forwardRef<HTMLAnchorElement, RouterLinkProps>((props, ref) => {
	return (
		<RouterLink
			ref={ref}
			{...props}
		/>
	);
});

Link.displayName = 'FuseLink';

export default Link;
